import { ISerializedActionCall } from "mobx-state-tree"
import { IAddCasesOptions, ICase } from "./data-set-types"

// TODO: define the types for the rest of the actions

export interface AddCasesAction extends ISerializedActionCall {
  name: "addCases"
  args: [ICase[], IAddCasesOptions | undefined]
}
export const isAddCasesAction = (action: ISerializedActionCall): action is AddCasesAction =>
              action.name === "addCases"

export interface SetCaseValuesAction extends ISerializedActionCall {
  name: "setCaseValues"
  args: [ICase[], string[] | undefined]
}
export const isSetCaseValuesAction = (action: ISerializedActionCall): action is SetCaseValuesAction =>
              action.name === "setCaseValues"

export interface SetComputedCaseValuesAction extends ISerializedActionCall {
  name: "setComputedCaseValues"
  args: [ICase[], string[]]
}
export const isSetComputedCaseValuesAction =
              (action: ISerializedActionCall): action is SetComputedCaseValuesAction =>
                action.name === "setComputedCaseValues"

// Matches either setCaseValues or setComputedCaseValues — use when responding to value changes
// regardless of whether they originated from user edits or formula evaluation.
export const isCaseValueChangeAction = (action: ISerializedActionCall):
              action is SetCaseValuesAction | SetComputedCaseValuesAction =>
              action.name === "setCaseValues" || action.name === "setComputedCaseValues"

export interface SetAttributeNameAction extends ISerializedActionCall {
  name: "setAttributeName"
  args: [string /*attributeID*/, string /*newName*/]
}
export const isSetAttributeNameAction = (action: ISerializedActionCall): action is SetAttributeNameAction =>
              action.name === "setAttributeName"

export interface RemoveCasesAction extends ISerializedActionCall {
  name: "removeCases"
  args: [string[]]
}
export const isRemoveCasesAction = (action: ISerializedActionCall): action is RemoveCasesAction =>
              action.name === "removeCases"

export interface SelectAllAction extends ISerializedActionCall {
  name: "selectAll"
  args: [boolean]
}

export interface SelectCasesAction extends ISerializedActionCall {
  name: "selectCases"
  args: [string[], boolean]
}

export interface SetSelectedCasesAction extends ISerializedActionCall {
  name: "setSelectedCases"
  args: [string[]]
}

export type PartialSelectionAction = SelectCasesAction | SetSelectedCasesAction
export type SelectionAction = PartialSelectionAction | SelectAllAction

export const isPartialSelectionAction = (action: ISerializedActionCall): action is PartialSelectionAction =>
              ["selectCases", "setSelectedCases"].includes(action.name)

export const isSelectionAction = (action: ISerializedActionCall): action is SelectionAction =>
              ["selectAll", "selectCases", "setSelectedCases"].includes(action.name)
